// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__udSP2","footer":"ModalUpdate_footer__-GAix"};